import { createContext } from "react";
import { Translator } from "../../../Utils/Translator";

export const TranslationContext = createContext<Translator>(null);
